






















































































































import { mapActions, mapGetters } from 'vuex';
import gql from 'graphql-tag';

import ZenButton from '@reciprocity/button';
import { BFormInput, BFormInvalidFeedback, BRow, BCol } from 'bootstrap-vue';

import { previewImage, fileToBase64 } from '@/utils';
import { uploadAvatar, deleteAvatar } from '@/utils/crudActions';

export default {
  name: 'UserProfilePage',
  components: {
    ZenButton,
    BFormInput,
    BFormInvalidFeedback,
    BRow,
    BCol,
  },
  data() {
    return {
      saving: false,
      uploadingPicture: false,
      clonedUser: {
        profileImageUrl: {
          value: null,
        },
      },
      homepageUrl: '',
      imageSelected: false,
    };
  },
  computed: {
    ...mapGetters({
      csrfToken: 'csrfToken',
      currentUser: 'currentUser',
    }),
    isSaveDisabled() {
      // TODO: also check if there is any change
      return this.uploadingPicture || this.saving;
    },
    isUploadDisabled() {
      return this.uploadingPicture || this.saving;
    },
    homepagePlaceholder() {
      return `Example: ${window.location.host}/dashboards`;
    },
    homepageValid() {
      const url = this.homepageUrl;
      const origin = `${window.location.origin}/`;
      const invalidUrls = ['/home', '/logout'];

      if (
        url &&
        ((!url.startsWith(origin) && !url.startsWith('/')) ||
          invalidUrls.some(u => url.includes(u)) ||
          (url.startsWith(origin) && url.length <= origin.length) ||
          (url.startsWith('/') && url.length === 1))
      ) {
        return false;
      }
      return null;
    },
    isAdmin() {
      return this.clonedUser.userRole.value === 'Administrator';
    },
  },
  created() {
    this.setPageTitle({ title: 'View and edit profile', visible: true });
    this.copyOriginalUser();
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
      showAlert: 'alerts/show',
      showModal: 'modals/show',
    }),
    copyOriginalUser() {
      this.clonedUser = JSON.parse(JSON.stringify(this.currentUser || {}));
    },
    openFileDialog() {
      (this.$refs.pictureUploadInput as HTMLElement).click();
    },
    async previewPicture() {
      try {
        this.uploadingPicture = true;
        this.imageSelected = true;
        const image = this.$refs.pictureUploadInput.files[0];
        const result = await previewImage(image);
        this.clonedUser.profileImageUrl.value = result;
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: 'Profile picture upload failed: invalid file format.',
        });
      }
      this.uploadingPicture = false;
    },
    async uploadImage() {
      this.uploadingPicture = true;
      try {
        const image = this.$refs.pictureUploadInput.files[0];
        const base64File = await fileToBase64(image);
        await uploadAvatar({ fileData: base64File, imageName: image.name, csrf: this.csrfToken });
        this.showAlert({
          type: 'success',
          message: 'New profile picture saved sucessfully.',
        });
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: (error.response.data && error.response.data.message) || 'Something went wrong.',
        });
      } finally {
        this.uploadingPicture = false;
        this.imageSelected = false;
        this.$refs.pictureUploadInput.value = null;
      }
    },
    async confirmDeleteImage() {
      try {
        await this.showModal({
          type: 'GenericConfirm',
          data: {
            title: 'Delete profile picture',
            message: 'You are about to delete your profile picture, this action is permanent.',
            okTitle: 'Delete',
          },
        });
        this.deleteImage();
      } catch {
        // User closed modal
      }
    },
    async deleteImage() {
      try {
        await deleteAvatar({ csrf: this.csrfToken });
        this.clonedUser.profileImageUrl.value = null;
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: (error.response.data && error.response.data.message) || 'Something went wrong.',
        });
      }
    },
    cancelChanges() {
      this.copyOriginalUser();
      this.$refs.pictureUploadInput.value = null;
      this.imageSelected = false;
    },
    saveHomepage() {
      const url = this.homepageUrl;

      this.$apollo
        .mutate({
          mutation: gql`
            mutation SaveUserHomepage($url: String!) {
              saveUserGlobalPreferences(data: { homeUrl: $url }) {
                result {
                  homeUrl
                }
              }
            }
          `,
          variables: {
            url,
          },
        })
        .then(() => {
          this.showAlert({
            type: 'success',
            message: 'Homepage saved successfuly.',
          });
        })
        .catch(() => {
          this.showAlert({
            type: 'error',
            message: 'Oops, something went wrong.',
          });
        });
    },
  },
  apollo: {
    homepageUrl: {
      query: gql`
        query {
          currentUser {
            globalPreferences {
              homeUrl
            }
          }
        }
      `,
      update: data => data.currentUser.globalPreferences.homeUrl,
    },
  },
};
